export const SET_UDP_VARS = "SET_UDP_VARS";


// WEBPACK FOOTER //
// ./modules/user-details-post-message/actions/actionTypes.ts